import { render } from "./BrightBlock.vue?vue&type=template&id=544eaedc"
import script from "./BrightBlock.vue?vue&type=script&lang=js"
export * from "./BrightBlock.vue?vue&type=script&lang=js"

import "./BrightBlock.vue?vue&type=style&index=0&id=544eaedc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__